import apiClient from './axios';

export const requestOtpForRegistration = (phone) => {
    return apiClient.post('/auth/registration/request-otp', { phone });
};

export const verifyOtpForRegistration = (payload) => {
    return apiClient.post('/auth/registration/verify-otp', payload);
};

